import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Table from '../../../../../facturotopia/table/Table';

const CuentaPredialList = (props) => {
  const handleEdit = (item) => {
    handleDelete(item);

    props.onEdit(item);
  };

  const handleDelete = (item) => {
    const newData = props.data.filter((value) => {
      return value.id !== item.id;
    });

    props.onChange(newData);
  };

  const { data = [] } = props;

  return (
    <Table
      columns={columns(handleEdit, handleDelete, props.editing)}
      rowKey={'id'}
      data={data}
    ></Table>
  );
};

const columns = (handleEdit, handleDelete, editing) => [
  {
    align: 'left',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            disabled={!!editing}
            onClick={handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={['far', 'edit']} />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={['fas', 'trash']} />
          </Button>
        </>
      );
    },
  },
  {
    align: 'center',
    key: 'Numero',
    title: 'Número predial',
    dataIndex: 'Numero',
  },
];

export default CuentaPredialList;
